import { render, staticRenderFns } from "./DashboardsView.vue?vue&type=template&id=0ff381a5"
import script from "./DashboardsView.vue?vue&type=script&lang=js"
export * from "./DashboardsView.vue?vue&type=script&lang=js"
import style0 from "./DashboardsView.vue?vue&type=style&index=0&id=0ff381a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports